var render = function () {
  var _vm$value, _vm$value$company, _vm$value$company$log, _vm$value2, _vm$value2$company, _vm$value2$company$lo, _vm$value3, _vm$value3$company, _vm$value4, _vm$value4$company, _vm$value5;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', {
    staticClass: "applied-card",
    attrs: {
      "rounded": "lg",
      "outlined": ""
    }
  }, [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    staticClass: "border-md-end min-w-md-200px min-w-lg-280px",
    attrs: {
      "cols": "12",
      "md": "auto"
    }
  }, [_c('v-layout', {
    staticClass: "w-100 h-100 pa-20",
    attrs: {
      "justify-center": "",
      "align-center": ""
    }
  }, [_c('v-img', {
    attrs: {
      "aspect-ratio": 166 / 36,
      "width": "166",
      "height": "36",
      "max-width": "166",
      "contain": "",
      "src": (_vm$value = _vm.value) === null || _vm$value === void 0 ? void 0 : (_vm$value$company = _vm$value.company) === null || _vm$value$company === void 0 ? void 0 : (_vm$value$company$log = _vm$value$company.logo) === null || _vm$value$company$log === void 0 ? void 0 : _vm$value$company$log.url
    }
  }, [_c('v-fade-transition', [_c('v-overlay', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !((_vm$value2 = _vm.value) !== null && _vm$value2 !== void 0 && (_vm$value2$company = _vm$value2.company) !== null && _vm$value2$company !== void 0 && (_vm$value2$company$lo = _vm$value2$company.logo) !== null && _vm$value2$company$lo !== void 0 && _vm$value2$company$lo.url),
      expression: "!value?.company?.logo?.url"
    }],
    attrs: {
      "absolute": "",
      "light": "",
      "color": "white"
    }
  }, [_c('image-overlay', [_vm._v(_vm._s((_vm$value3 = _vm.value) === null || _vm$value3 === void 0 ? void 0 : (_vm$value3$company = _vm$value3.company) === null || _vm$value3$company === void 0 ? void 0 : _vm$value3$company.name))])], 1)], 1)], 1)], 1)], 1), _c('v-col', {
    staticClass: "applied-card__info",
    attrs: {
      "cols": "12",
      "md": ""
    }
  }, [_c('div', {
    staticClass: "pa-20 pa-md-24"
  }, [_c('v-row', {
    staticClass: "row--large",
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    staticClass: "applied-card__detail mb-10 mb-md-0",
    attrs: {
      "cols": "12",
      "md": "auto"
    }
  }, [_c('p', {
    staticClass: "page-text page-text--sm primary--text mb-4"
  }, [_vm._v(_vm._s((_vm$value4 = _vm.value) === null || _vm$value4 === void 0 ? void 0 : (_vm$value4$company = _vm$value4.company) === null || _vm$value4$company === void 0 ? void 0 : _vm$value4$company.name))]), _c('h5', {
    staticClass: "page-text--lg font-wieght-medium mb-4"
  }, [_vm._v(" " + _vm._s((_vm$value5 = _vm.value) === null || _vm$value5 === void 0 ? void 0 : _vm$value5.title) + " ")]), _c('v-row', {
    staticClass: "row--small",
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    staticClass: "applied-card__link"
  }, [_c('p', {
    staticClass: "page-text grey--text line-height-15"
  }, [_vm._v("매칭URL: " + _vm._s(_vm.matchUrl))])]), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', {
    attrs: {
      "href": _vm.matchUrl,
      "text": "",
      "icon": "",
      "small": "",
      "color": "grey"
    }
  }, [_c('v-icon', [_vm._v("mdi-link")])], 1)], 1)], 1), _c('meeting-list-item-matching', _vm._b({}, 'meeting-list-item-matching', {
    value: _vm.value
  }, false))], 1), _c('v-col', {
    staticClass: "mb-10 mb-md-0",
    attrs: {
      "cols": "12",
      "md": ""
    }
  }, [_c('div', {
    staticClass: "min-w-120px"
  }, [_c('p', {
    staticClass: "page-text--sm grey-9--text mb-4"
  }, [_vm._v("상태")]), _c('v-layout', {
    attrs: {
      "align-center": ""
    }
  }, [_c('i', {
    class: 'mr-4 icon icon-dot icon-dot--' + _vm.stateColor
  }), _c('h5', {
    staticClass: "page-text--lg font-weight regular"
  }, [_vm._v(" " + _vm._s(_vm.stateText) + " ")])]), _c('v-fade-transition', [_c('v-overlay', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.loading,
      expression: "loading"
    }],
    attrs: {
      "absolute": "",
      "light": "",
      "color": "white"
    }
  }, [_c('v-progress-circular', {
    attrs: {
      "size": "40",
      "width": "2",
      "indeterminate": "",
      "color": "primary"
    }
  })], 1)], 1)], 1)]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "auto"
    }
  }, [_c('v-layout', {
    attrs: {
      "column": "",
      "align-end": ""
    }
  }, [_c('meeting-view', _vm._b({
    on: {
      "input": function input(value) {
        return _vm.$emit('input', value);
      }
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var attrs = _ref.attrs,
          on = _ref.on;
        return [_c('v-btn', _vm._g(_vm._b({
          staticClass: "w-100 mw-lg-100px mb-8",
          attrs: {
            "small": "",
            "outlined": "",
            "color": "primary"
          }
        }, 'v-btn', attrs, false), on), [_vm._v(" 미팅일정 선택 ")])];
      }
    }])
  }, 'meeting-view', {
    value: _vm.value
  }, false)), _c('v-fade-transition', {
    attrs: {
      "leave-absolute": ""
    }
  }, [_c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.showsScheduleDate,
      expression: "!showsScheduleDate"
    }],
    staticClass: "w-100 mw-lg-100px",
    attrs: {
      "small": "",
      "outlined": "",
      "color": "primary"
    },
    on: {
      "click": function click($event) {
        _vm.showsScheduleDate = true;
      }
    }
  }, [_vm._v("미팅 일정 확인")])], 1), _c('v-fade-transition', {
    attrs: {
      "hide-on-leave": ""
    }
  }, [_c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showsScheduleDate,
      expression: "showsScheduleDate"
    }],
    attrs: {
      "small": "",
      "color": "grey-ec"
    },
    on: {
      "click": function click($event) {
        _vm.showsScheduleDate = false;
      }
    }
  }, [_c('span', {
    staticClass: "grey-13--text"
  }, [_vm._v(_vm._s(_vm.scheduleDateText)), _c('v-icon', {
    staticClass: "ml-6",
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-check")])], 1)])], 1)], 1)], 1)], 1)], 1)])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }